import React from 'react'

import Select from 'react-tailwindcss-select'
import { Input } from '@material-tailwind/react'

import LoadingButton from '@/Shared/LoadingButton'
import DatePicker from '@/Shared/DatePicker'
import DeleteButton from '@/Shared/DeleteButton'

export default function({
                            handleSubmit,
                            hospitals,
                            errors,
                            data,
                            setData,
                            processing,
                            isDeleted,
                            destroy,
                            isEdit
                        }) {
    return (
        <form name="createForm" onSubmit={handleSubmit} className="mt-8">
            <div className="flex flex-col gap-4 md:flex-row">
                {typeof hospitals === 'object' && (
                    <Select
                        label="Select Hospital"
                        name="role"
                        error={errors.hospital_id}
                        primaryColor="indigo"
                        value={
                            data.hospital_id && {
                                value: data.hospital_id,
                                label: hospitals.find(
                                    hospital => hospital.id === data.hospital_id
                                ).name
                            }
                        }
                        isSearchable
                        options={hospitals.map(hospital => ({
                            label: hospital.name,
                            value: hospital.id
                        }))}
                        onChange={option => setData('hospital_id', option.value)}
                    />
                )}

                <Input
                    size="lg"
                    label="Firm"
                    name="firm"
                    error={errors.firm}
                    value={data.firm}
                    onChange={e => setData('firm', e.target.value)}
                />
            </div>

            <div className="mt-6 flex flex-col gap-4 md:flex-row">
                <Input
                    size="lg"
                    label="Brooms KG"
                    name="brooms"
                    type="number"
                    error={errors.brooms}
                    value={data.brooms}
                    onChange={e => setData('brooms', e.target.value)}
                />

                <Input
                    size="lg"
                    label="Wiper 2.5 ft Width No"
                    name="wiper"
                    type="number"
                    error={errors.wiper}
                    value={data.wiper}
                    onChange={e => setData('wiper', e.target.value)}
                />
            </div>

            <div className="mt-6 flex flex-col gap-4 md:flex-row">
                <Input
                    size="lg"
                    label="Normal Waste Bags 21x28"
                    name="normal_waste_21_bag"
                    type="number"
                    error={errors.normal_waste_21_bag}
                    value={data.normal_waste_21_bag}
                    onChange={e => setData('normal_waste_21_bag', e.target.value)}
                />

                <Input
                    size="lg"
                    label="Normal Waste Bags 30x30"
                    name="normal_waste_30_bag"
                    type="number"
                    error={errors.normal_waste_30_bag}
                    value={data.normal_waste_30_bag}
                    onChange={e => setData('normal_waste_30_bag', e.target.value)}
                />
            </div>

            <div className="mt-6 flex flex-col gap-4 md:flex-row">
                <Input
                    size="lg"
                    label="Normal Waste Bags 39x45"
                    name="normal_waste_39_bag"
                    type="number"
                    error={errors.normal_waste_39_bag}
                    value={data.normal_waste_39_bag}
                    onChange={e => setData('normal_waste_39_bag', e.target.value)}
                />

                <Input
                    size="lg"
                    label="Furniture Dusters No"
                    name="furniture_dusters"
                    type="number"
                    error={errors.furniture_dusters}
                    value={data.furniture_dusters}
                    onChange={e => setData('furniture_dusters', e.target.value)}
                />
            </div>

            <div className="mt-6 flex flex-col gap-4 md:flex-row">
                <Input
                    size="lg"
                    label="Disinfectant (2500-3000 ml)"
                    name="disinfectant"
                    type="number"
                    error={errors.disinfectant}
                    value={data.disinfectant}
                    onChange={e => setData('disinfectant', e.target.value)}
                />

                <Input
                    size="lg"
                    label="Hand Wash liquid (500 ml)"
                    name="hand_wash_liquid"
                    type="number"
                    error={errors.hand_wash_liquid}
                    value={data.hand_wash_liquid}
                    onChange={e => setData('hand_wash_liquid', e.target.value)}
                />
            </div>

            <div className="mt-6 flex flex-col gap-4 md:flex-row">
                <Input
                    size="lg"
                    label="Air Freshener (300-500 ml)"
                    name="air_freshener"
                    type="number"
                    error={errors.air_freshener}
                    value={data.air_freshener}
                    onChange={e => setData('air_freshener', e.target.value)}
                />

                <Input
                    size="lg"
                    label="Mop Pads"
                    name="mop_pads"
                    type="number"
                    error={errors.mop_pads}
                    value={data.mop_pads}
                    onChange={e => setData('mop_pads', e.target.value)}
                />
            </div>

            <div className="mt-6 flex flex-col gap-4 md:flex-row">
                <Input
                    size="lg"
                    label="Liquid Toilet Cleaner (250 ml)"
                    name="liquid_toilet_cleaner"
                    type="number"
                    error={errors.liquid_toilet_cleaner}
                    value={data.liquid_toilet_cleaner}
                    onChange={e => setData('liquid_toilet_cleaner', e.target.value)}
                />

                <Input
                    size="lg"
                    label="Floor Mops Standard No"
                    name="floor_mops_standard"
                    type="number"
                    error={errors.floor_mops_standard}
                    value={data.floor_mops_standard}
                    onChange={e => setData('floor_mops_standard', e.target.value)}
                />
            </div>

            <div className="mt-6 flex flex-col gap-4 md:flex-row">
                <Input
                    size="lg"
                    label="Hand Wash Dispenser"
                    name="hand_wash_dispenser"
                    type="number"
                    error={errors.hand_wash_dispenser}
                    value={data.hand_wash_dispenser}
                    onChange={e => setData('hand_wash_dispenser', e.target.value)}
                />

                <Input
                    size="lg"
                    label="Floor Cleaning Towels (small size) No"
                    name="floor_cleaning_towels"
                    type="number"
                    error={errors.floor_cleaning_towels}
                    value={data.floor_cleaning_towels}
                    onChange={e => setData('floor_cleaning_towels', e.target.value)}
                />
            </div>

            <div className="mt-6 flex flex-col gap-4 md:flex-row">
                <Input
                    size="lg"
                    label="Air Freshener Dispenser (Machines)"
                    name="air_freshener_2"
                    type="number"
                    error={errors.air_freshener_2}
                    value={data.air_freshener_2}
                    onChange={e => setData('air_freshener_2', e.target.value)}
                />

                <Input
                    size="lg"
                    label="Air Freshener Dispenser Refills"
                    name="air_freshener_3"
                    type="number"
                    error={errors.air_freshener_3}
                    value={data.air_freshener_3}
                    onChange={e => setData('air_freshener_3', e.target.value)}
                />
            </div>

            <div className="mt-6 flex flex-col gap-4 md:flex-row">
                <Input
                    size="lg"
                    label="Disposable Bedsheets"
                    name="disposable_bed_sheets"
                    type="number"
                    error={errors.disposable_bed_sheets}
                    value={data.disposable_bed_sheets}
                    onChange={e => setData('disposable_bed_sheets', e.target.value)}
                />

                <DatePicker
                    date={data.arrived_date}
                    setDate={date => setData('arrived_date', date)}
                />
            </div>

            <div
                className={`mt-8 flex items-center ${(isEdit && !isDeleted) ? 'justify-between' : 'justify-end'} border-t border-gray-200 bg-gray-100 px-8 py-4`}>
                {isEdit && !isDeleted && (
                    <DeleteButton onDelete={destroy}>Delete Entry</DeleteButton>
                )}

                <LoadingButton
                    loading={processing}
                    type="submit"
                    className="btn-indigo"
                >
                    {isEdit ? 'Update' : 'Add'} Item
                </LoadingButton>
            </div>
        </form>
    )
}
